import { US } from './country-codes';

export const CustomsReason = Object.freeze({
  NotRequired: 'NotRequired',
  InternationalShipment: 'InternationalShipment',
  UnitedStatesMilitaryAddress: 'UnitedStatesMilitaryAddress',
  UnitedStatesTerritoryOrProtectorate: 'UnitedStatesTerritoryOrProtectorate',
  BfpoAddress: 'BfpoAddress',
  UnitedKingdomLocation: 'UnitedKingdomLocation',
  SpecialTerritoryRequirement: 'SpecialTerritoryRequirement',
  ChannelIslandTransport: 'ChannelIslandTransport',
  RequireWindsorDeclaration: 'RequireWindsorDeclaration',
  RequireMovementIndicator: 'RequireMovementIndicator',
});
export const recipientCountriesForTariffs = [US];

export const euCountryCodes = Object.freeze([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
]);
